module.exports = __webpack_public_path__ + "fonts/instagram.svg?v=7c1dafd7f6190fd0723f48639382bd3b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/instagram.svg
// module id = 692
// module chunks = 0